import React, { memo, useEffect, useState } from "react";
import {
  Stack,
  Typography,
  Card,
  CardContent,
  Box,
  Button,
  useMediaQuery,
  Icon,
} from "investira.react.components";
import { validators } from "investira.sdk";

const PerfilSection = memo((props) => {
  const { perfil, pessoa, maxLines = 6 } = props;

  const isUpLg = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const [isExpanded, setIsExpanded] = useState(false);
  const [linesMax, setLinesMax] = useState(maxLines);

  useEffect(() => {
    if (isUpLg) {
      setLinesMax(14);
    } else {
      setLinesMax(6);
    }
  }, [isUpLg]);

  console.log(perfil);

  if (
    // validators.isNull(perfil.data) ||
    validators.isNull(perfil) ||
    validators.isEmpty(perfil)
  ) {
    return null;
  }

  const content = (
    <>
      <Typography variant="h6" component="h3" gutterBottom color="textPrimary">
        Sobre a Empresa
      </Typography>
      <Typography variant="body2" color="textPrimary" gutterBottom>
        {perfil.perfil.origem}
      </Typography>
      <Typography variant="body2" color="textPrimary" gutterBottom>
        {perfil.perfil.descricao}
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        color="textPrimary"
        sx={{ fontWeight: "600" }}
        component="h4"
      >
        Relevância
      </Typography>
      <Typography variant="body2" color="textPrimary" gutterBottom>
        {perfil.perfil.relevancia}
      </Typography>
      {perfil.perfil.desafio && (
        <Typography
          variant="subtitle1"
          gutterBottom
          color="textPrimary"
          sx={{ fontWeight: "600" }}
          component="h4"
        >
          Desafio
        </Typography>
      )}
      {perfil.perfil.desafio && (
        <Typography variant="body2" color="textPrimary">
          {perfil.perfil.desafio}
        </Typography>
      )}
    </>
  );

  return (
    <Stack
      sx={{
        flex: 2,
        minWidth: 0,
      }}
      component="section"
      aria-label={`Sobre a empresa ${pessoa.pessoa_fantasia || pessoa.pessoa}`}
    >
      <Card sx={{ height: "100%" }}>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box p={2}>
            <Box
              sx={{
                overflow: "hidden",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: isExpanded ? "none" : linesMax,
                textOverflow: "ellipsis",
              }}
            >
              {content}
            </Box>

            {/* {!isUpLg && (
            <Stack alignItems="flex-end" pt={2}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{ mt: 1 }}
              >
                {isExpanded ? "Mostrar menos" : "Mostrar mais"}
              </Button>
            </Stack>
          )} */}

            <Stack
              alignItems="center"
              direction="row"
              justifyContent="space-between"
              pt={1}
            >
              {pessoa.infos?.site && (
                <Stack direction="row" py={2} spacing={1} alignItems="center">
                  <Icon iconName="earth" size={18} color="primary" />
                  <Typography
                    variant="body2"
                    color="primary"
                    component="a"
                    href={`https://${pessoa.infos?.site.toLowerCase()}`}
                    rel="external"
                    sx={{
                      pointerEvents: "all",
                    }}
                    gutterBottom
                  >
                    {pessoa.infos?.site.toLowerCase()}
                    <span aria-hidden="true">↗</span>
                  </Typography>
                </Stack>
              )}
              <Button
                size="small"
                variant="outlined"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "Mostrar menos" : "Mostrar mais"}
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default PerfilSection;
